// components
import ToolbarActionMenu from './ToolbarActionMenu';
import { StyledToolbarContainer } from './Toolbar.styles';
import DateNavigation from 'components/shared/DateNavigation/DateNavigation';
import { ActionStrip } from './ActionStrip';

// enums
import { ToolbarFlowEnum } from '../ToolbarWrapper.enums';

// styles
import { DateNavigationContainer } from 'components/shared/Header/Header.styles';

// types
import { ToolbarProps } from './Toolbar.types';
import { cloneElement, isValidElement } from 'react';

const Toolbar = ({
  actions,
  additionalActions,
  dateNavigation,
  isRightPositioned,
  isZenPositioned,
  setToolbarPosition,
  onMouseEnterZen,
  onMouseLeaveZen,
  zenOpen,
  planUnitSelector,
  toolbarFlow = ToolbarFlowEnum.GRID,
  component
}: ToolbarProps) => {
  const isVertical = isRightPositioned || isZenPositioned;
  const alignRightActions = actions?.filter(
    (action) => action.alignment === 'right'
  );
  const alignLeftActions = actions?.filter(
    (action) => action.alignment === 'left'
  );

  return (
    <StyledToolbarContainer
      isRightPositioned={isRightPositioned}
      isZenPositioned={isZenPositioned}
      zenOpen={zenOpen}
      onMouseEnter={onMouseEnterZen}
      onMouseLeave={onMouseLeaveZen}
      toolbarFlow={toolbarFlow}
    >
      <ActionStrip
        items={alignLeftActions}
        planUnitSelector={planUnitSelector}
        isVertical={isVertical}
      />

      {isValidElement(component?.beforeDatePicker)
        ? cloneElement(component.beforeDatePicker, {
            isRightPositioned: isRightPositioned || isZenPositioned
          })
        : component?.beforeDatePicker}

      {dateNavigation?.showDateNavigation && (
        <DateNavigationContainer
          data-tourid={dateNavigation?.dateNavigationDataTourId}
        >
          <DateNavigation
            defaultPeriod="month"
            defaultDate={dateNavigation?.selectedDate}
            defaultDateRange={dateNavigation?.selectedDateRange}
            onDateChange={dateNavigation?.onSelectedDate}
            options={dateNavigation?.dateNavigationOptions}
            allowMenuOptions={dateNavigation?.allowDateNavigationMenuOptions}
            isToolbar
            isRightPositioned={isRightPositioned || isZenPositioned}
          />
        </DateNavigationContainer>
      )}

      {isValidElement(component?.afterDatePicker)
        ? cloneElement(component.afterDatePicker, {
            isRightPositioned: isRightPositioned || isZenPositioned
          })
        : component?.afterDatePicker}

      <ActionStrip items={alignRightActions} justifyEnd isVertical={isVertical}>
        <ToolbarActionMenu
          additionalActions={additionalActions}
          isAdditionalActions
          setToolbarPosition={setToolbarPosition}
          isRightPositioned={isVertical}
        />
      </ActionStrip>
    </StyledToolbarContainer>
  );
};

export default Toolbar;
